var render = function render(){var _vm=this,_c=_vm._self._c;return (!(_vm.msg.slug === 'typing'))?_c('div',{staticClass:"bot-msg msg-wrapper"},[_c('div',{staticClass:"msg-content"},[(_vm.msg.slug)?_c(_vm.getFileName(_vm.msg.slug),{tag:"component",attrs:{"con":_vm.msg}}):(_vm.msg.channelData)?_c(_vm.getFileName(_vm.msg.channelData.slug),{tag:"component",attrs:{"con":_vm.msg.channelData}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }